'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deleteButton = _interopRequireDefault(require("./../delete-button"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DeleteButtonProject = /*#__PURE__*/function (_React$Component) {
  _inherits(DeleteButtonProject, _React$Component);

  function DeleteButtonProject(props) {
    _classCallCheck(this, DeleteButtonProject);

    return _possibleConstructorReturn(this, (DeleteButtonProject.__proto__ || Object.getPrototypeOf(DeleteButtonProject)).call(this, props));
  }

  _createClass(DeleteButtonProject, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
        id: this.props.id,
        history: this.props.history,
        url: this.props.urlTemplate,
        asButton: false,
        label: t('delete project registration'),
        language: this.props.i18n.language,
        labelConfirmButton: t('delete project registration'),
        labelCancel: t('cancel'),
        labelConfirmation: t('Are you sure the delete this project registration?'),
        labelSuccess: t('Project registration was deleted'),
        labelConfirmed: t('Project registration was deleted'),
        labelDeleteFailed: t('Project registration could not be deleted'),
        labelNext1: t('To dashboard'),
        pathNext1: '/',
        labelNext2: t('To project list'),
        pathNext2: '/projects'
      });
    }
  }]);

  return DeleteButtonProject;
}(_react.default.Component);

DeleteButtonProject.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  history: _propTypes.default.object.isRequired,
  id: _propTypes.default.number.isRequired,
  urlTemplate: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(DeleteButtonProject);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/delete-button-project/index.js
// module id = 70
// module chunks = 0